// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aRRW","delete":"styles_delete__2Bs2m","update":"styles_update__1GXMO","add":"styles_add__1QX6S"};